import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import Cookies from 'js-cookie';

// Set your API base URL
const BASE_URL = process.env.REACT_APP_BASE_URL;
export const PieChart = createAsyncThunk(
  'chart/PieChart',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/chart/PieChart1`, {
        headers: {
          Authorization: `Bearer ${Cookies.get('token')}`,
        },
      });
      return response.data;
    } catch (error) {
      console.log(error, "-------errorerror-----------")
      return rejectWithValue(error.response.data);
    }
  }
);


export const fetchAllUserCount = createAsyncThunk(
  "platform/fetchAllUserCount",
  async (_, { rejectWithValue }) => {
    try {
      // const response = await axios.get(`${BASE_URL}/FB/Conversation`, {
      const response = await axios.get(`${BASE_URL}/facebook/count1`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
        },
      });
      return response?.data?.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);



export const getConversationAnalytics = createAsyncThunk(
  'chart/getConversationAnalytics',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/chart/conversation-analytics`, {
        headers: {
          Authorization: `Bearer ${Cookies.get('token')}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch analytics');
    }
  }
);